import { RoundTrend } from "./comparison-trend.js";
import { ComparisonPoints } from "./comparison-points.js";
import { ComparisonMetricTable } from "./comparison-metric-table.js";
import { displaySides } from "./comparison-presentation.js";
import { type AnalysisProps } from "./comparison-observation.js";

export function ComparisonPerformance(
  props: AnalysisProps,
): React.JSX.Element | null {
  const data = props.detail.performance;
  if (!data?.rounds.length) return null;
  const sides = displaySides(props.detail.relation);
  return (
    <>
      <RoundTrend {...props} />
      <h2>Scoring profile</h2>
      <div>
        {data.scoring.map((row) => (
          <ComparisonPoints
            key={row.label}
            label={row.label}
            names={[
              props.detail.relation[sides[0]].name,
              props.detail.relation[sides[1]].name,
            ]}
            values={[row[sides[0]], row[sides[1]]]}
            decimals={0}
            higherWins={
              row.label === "Eagle+" ||
              row.label === "Birdie" ||
              row.label === "Par"
            }
            description={
              ["Eagle+", "Birdie", "Par"].includes(row.label)
                ? "Holes scored · Higher is better"
                : "Holes scored · Lower is better"
            }
            sample="Shared holes"
          />
        ))}
      </div>
      <ComparisonMetricTable
        {...props}
        rows={data.parTypes
          .filter((row) => row.observation.n)
          .map((row) => ({
            label: `Par ${row.par}`,
            observation: row.observation,
          }))}
      />
    </>
  );
}
